/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Media_VideoInputs */



/**
* | output |
* | --- |
* | "Video" |
*
* @param {Community_Media_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_media_video = /** @type {((inputs?: Community_Media_VideoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Media_VideoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vidéo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vídeo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vídeo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Video")
	return /** @type {LocalizedString} */ ("Video")
});